export enum TabKey {
  UPDATE = '1',
  INSERT = '2',
  REMOVE = '3',
}
